import Vue from "vue";
import store from "./store/store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./plugins/api";
import App from "./App.vue";
import "@/assets/icons/iconfont.css";
import router from "./router";

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
